<template>
<div id="headercommon">
  <div class="headercommon-title">国合基地信息采集系统</div>
  <div @click.stop="dropshow=!dropshow"  class="username">

    <img src="../../assets/img/user_head.png" alt />
    <span>{{userName}}</span>
    <i class="el-icon-arrow-down el-icon--right"></i>
    <transition name="el-zoom-in-top">
      <div v-show="dropshow" class="nav_down_wrapper">
        <div class="nav_down" @click="changepassword" v-show="dropshow">
          <img style="width:16px;height:16px" src="../../assets/img/changepassword.png" />
          <span>修改密码</span>
        </div>
        <div class="nav_down" @click="delPremission">
          <img style="width:16px;height:16px" src="../../assets/img/logout.png" />
          <span>注销</span>
        </div>
      </div>
    </transition>


  </div>
</div>
</template>

<script>
    export default {
        name: "header-common",
        props:{
        islogout:{
          default:false,
          type:Boolean
        }
      },
        data(){
            return{
              userName:LocalStorage.get('datacollect_userName')?LocalStorage.get('datacollect_userName'):'你好',
              dropshow: false,
            }
        },
      watch: {
        islogout(val) {
          this.delPremission();
        }
      },
      methods:{
        delPremission() {

          if(!LocalStorage.get('datacollect_remember')){
            LocalStorage.del('datacollect_remember');
            LocalStorage.del('datacollect_userId');
            LocalStorage.del('datacollect_pwd');
          }
          LocalStorage.del('datacollect_userName');
          LocalStorage.del('datacollect_token');

          this.$store.commit('SET_Menulist', []);
          this.$store.commit('SET_UserButton', []);
          this.$store.commit('SET_temId', '');


          this.$router.replace({name: 'login'})
        },
        //修改密码
        changepassword(){
          this.$emit('changepassword',true);
        },
        hidden() {
          this.dropshow = false
        },
      }
    }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
#headercommon{
  width: 100%;
  height: 70px;
  background-color: #0a7afc;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  .headercommon-title{
      float: left;
      margin-left: 30px;
      font-size: 32px;
      line-height: 70px;
      color: #ffffff;
  }
  .username {
    float: right;
    color: #f5faff;
    display: flex;
    align-items: center;
    user-select: none;
    height: 60px;
    justify-content: center;
    margin-right: 35px;
    img {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }
    span {
      font-size: 14px;
      display: inline-block;
      user-select: none;
    }
    .badge {
      position: absolute;
      right: -15px;
    }
    i {
      font-size: 20px;
      color: #f5faff;
    }
  }
  div.nav_down_wrapper {
    display: block;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    position: absolute;
    top: 50px;
    right: 30px;
    // transform: translateX(-65%);
    width: 115px;
    background-color: #fff;
    user-select: none;
    div.nav_down {
      height: 40px;
      position: relative;
      padding: 0 15px;
      transition: all 0.3s;
      display: flex;
      align-items: center;
      user-select: none;
      img {
        user-select: none;
      }
      span {
        margin-left: 5px;
        color: #666;
        font-size: 13px;
      }
      &:hover {
        background-color: #ecf5ff;
        transition: all 0.3s;
        span {
          color: #1998fb;
        }
      }
    }
  }
  /deep/ .el-dropdown {
    color: #1998fb;
    margin-right: 20px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/HeaderCommon/index.vue